import React from 'react'
import { useSimulation } from '../state'
import { TaskItem } from './TaskItem'

export const TaskPanel = () => {
  const [state] = useSimulation()
  const { title, tasks, allComplete, completionUrl, completionButtonText, pluginConfig } = state

  const coursenum = pluginConfig ? pluginConfig.coursenum : ''
  const href = completionUrl || (coursenum ? `/reader/web/${coursenum}/` : '#')
  const btnText = completionButtonText || 'Continue'

  return (
    <div className="simulation-task-panel">
      {title && <h2 className="simulation-task-panel-title">{title}</h2>}
      <div className="simulation-task-list" role="list" aria-label="Simulation tasks">
        {tasks.map((task, index) => (
          <TaskItem key={task.id} task={task} index={index} />
        ))}
      </div>
      {allComplete && (
        <div className="simulation-complete-section" role="status">
          <div className="simulation-complete-icon">&#10003;</div>
          <h3>All Tasks Complete</h3>
          <p>You have finished all tasks in this simulation.</p>
          <a href={href} className="simulation-complete-btn">{btnText}</a>
        </div>
      )}
    </div>
  )
}
